import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import ReactCodeInput from 'react-code-input';
import { withRouter } from 'react-router-dom';
import {
  formatEmailSameLength,
  setSEOIndexOff,
  toastDefaultOptions,
  redirectToLtiCourseIfExists
} from '../../utils/functions';
import adsTracking from '../../utils/adsTracking';
import { gateway } from '../../utils/api';
import RetornoLogin from './RetornoLogin';
import { LitTitle } from '../shared/LitTitle';
import { LitText } from '../shared/LitText';
import { LitButton } from '../shared/LitButton';

const LoginHeader = styled(LitTitle)`
  font-family: 'Dosis', sans-serif;
  font-size: 2.2em;
  margin-bottom: 20px !important;
  font-stretch: condensed;
  color: #27aae1;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.8em;
    margin-bottom: 15px !important;
  }
`;

const CardContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 550px;
  margin: 0 auto;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    border-radius: 0;
    box-shadow: none;
    max-width: 100%;
  }
`;

const Wrapper = styled.div`
  max-width: 100%;
  
  @media (max-width: 768px) {
    width: 100%;
    
    .criar-conta {
      margin-bottom: 1.5rem;
      
      p {
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
      }
    }
    
    form {
      width: 100%;
      
      .row {
        margin: 0;
        
        label {
          width: 100%;
          text-align: center;
          margin-bottom: 0.75rem;
        }
      }
    }
  }
`;

const CodeInputContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0;
  
  .react-code-input {
    display: flex !important;
    gap: 0.1rem;
    justify-content: center;
    
    input {
      width: 40px !important;
      height: 50px !important;
      border: 2px solid #27aae1 !important;
      border-radius: 8px !important;
      text-align: center !important;
      font-size: 1.2rem !important;
      font-weight: 600 !important;
      color: #27aae1 !important;
      background: #fff !important;
      transition: all 0.3s ease !important;
      padding-left: 0 !important;
      
      &:focus {
        outline: none !important;
        border-color: #02c4fd !important;
        box-shadow: 0 0 0 3px rgba(39, 170, 225, 0.1) !important;
        background: #f8fbff !important;
      }
      
      @media (max-width: 768px) {
        width: 35px !important;
        height: 45px !important;
        font-size: 1rem !important;
      }
    }
  }
`;

class RightSideBar extends Component {
  state = {
    code: '',
    error: '',
    loading: false,
    isRender: true,
    hasOrigin: false
  };

  componentDidMount() {
    const path = window.location.pathname.split('/');
    const code = path[2];

    if (code !== 'confirmarEmail') {
      this.setState({ code }, this.confirmEmail);
    }
    this.setState({ isRender: false });
    setSEOIndexOff();

    this.getUrlParams();
  }

  getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    const plans = params.get('plans');
    if (plans) {
      localStorage.setItem('urlPlansParam', plans);
    }

    const origemParam = params.get('o');
    const loginTenant = params.get('tenant');
    if (loginTenant) {
      localStorage.setItem('loginTenant', loginTenant);
    }
    if (origemParam) {
      localStorage.setItem('urlOriginParam', origemParam);
      localStorage.setItem('urlRedirect', origemParam);
      this.setState({ hasOrigin: true });
    }
  };

  setItensLocalStorage = dados => {
    localStorage.setItem('ra', dados.ra);
    localStorage.setItem('idProfile', dados.idProfile);
    localStorage.setItem('voucherAtivo', dados.voucherAtivo);
    localStorage.setItem('finishOnBoarding', false);
    localStorage.setItem('57e0854551b1dca003c67c384c37a346', false);
    localStorage.setItem('firstName', dados.firstName);
    localStorage.setItem('lastName', dados.lastName);
    localStorage.setItem('idMember', dados.groupMember);
    localStorage.setItem('idOwner', dados.ownerGroup);
    localStorage.setItem('idRA', dados.idRA);
    localStorage.setItem('idLogin', dados.idLogin);
    localStorage.setItem('freeUser', dados.freeUser);
    localStorage.setItem('libraryUser', dados.libraryUser);
    localStorage.setItem('socialUser', dados.socialUser);
    localStorage.setItem('completedPersonality', dados.completedPersonality);
    localStorage.setItem('modalNotas', dados.messagesCount > 0);
    localStorage.setItem('showPaul', dados.showPaul);
    localStorage.setItem(
      'dateLogin',
      `${new Date().getDate()}/${new Date().getMonth()}`
    );
  };

  confirmEmail = async e => {
    if (e) {
      e.preventDefault();
    }
    const { code, hasOrigin } = this.state;
    const { history } = this.props;
    if (!code) {
      this.notify('Digite o código');
      return;
    }
    this.setState({ loading: true });

    const url = `/webbff/lit_app_web/auth/receiveConfirmation/${code}${hasOrigin ? '?hasOrigin=true' : ''}`;
    try {
      const response = await gateway.post(url);
      const firstLogin = JSON.parse(localStorage.getItem('firstLogin'));
      let activeContract = false;
      if (localStorage.getItem('activeContract') !== 'undefined') {
        activeContract = JSON.parse(localStorage.getItem('activeContract'));
      }
      this.notify(response.message);
      if (response.status === 200) {
        adsTracking.sendGoogleAnalyticsEcommerceEvent({
          step: adsTracking.STEP2_EMAIL_CONFIRMATION
        });
        if (response.email) {
          if (!activeContract) {
            history.push('/consultaCpf');
          } else if (firstLogin) {
            history.push('/onboarding');
          } else if (!redirectToLtiCourseIfExists()) {
              history.push('/home');
            }
        } else {
          setTimeout(() => {
            history.push('/');
          }, 1000);
        }
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
      this.notify(error.response.data.message);
    }
  };

  notify = (text, timeClose = 4000) => {
    toast(text, {
      ...toastDefaultOptions,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: timeClose
    });
  };

  render() {
    const ra = localStorage.getItem('ra');
    const email = ra ? formatEmailSameLength(ra) : null;

    const { code, loading, error, isRender } = this.state;
    return (
      <CardContainer>
        <LoginHeader>Confirmação de email</LoginHeader>
        <Wrapper>
          <div className="criar-conta">
            <LitText>
              Por favor, verifique sua caixa de entrada ou spam para confirmar
              seu endereço de email. Clique no link no email ou cole abaixo o
              código de confirmação.
            </LitText>
            {email && <LitText style={{ marginTop: '0.5rem', fontWeight: 500 }}>Email enviado para: {email}</LitText>}
          </div>
          <form style={{ marginTop: '2em' }} onSubmit={this.confirmEmail}>
            <div className="row justify-content-center align-items-center">
              <label htmlFor="inputcodigoEmail">
                <LitText style={{ fontWeight: 600 }}>Código de confirmação</LitText>
              </label>
            </div>
            <CodeInputContainer>
              {!isRender && (
                <ReactCodeInput
                  forceUppercase
                  id="inputcodigoEmail"
                  onChange={evt => this.setState({ code: evt })}
                  type="text"
                  value={code}
                  fields={8}
                />
              )}
            </CodeInputContainer>

            {error && (
              <div className="row">
                <div className="col">
                  <LitText style={{ color: '#e50000', textAlign: 'center', marginTop: '0.5rem' }}>{error}</LitText>
                </div>
              </div>
            )}

            <div className="row justify-content-center" style={{ marginTop: '2rem' }}>
              <LitButton
                type="submit"
                disabled={loading || !code || code.length < 8}
                style={{
                  textTransform: 'uppercase',
                  minWidth: '200px'
                }}
                className={`${loading && ' btn-loading'}`}
              >
                Confirmar
              </LitButton>
            </div>
          </form>
          <RetornoLogin notif={this.notify} />
        </Wrapper>
      </CardContainer>
    );
  }
}

export default withRouter(RightSideBar);
